
const setHeight = {
  bind(el, binding, vnode, old) {
    setTimeout(() => {
      const selector = `.${binding.value}`
      const sctionsEl = document.querySelector(selector)
      if (!sctionsEl) return

      let headersSize = 0
      const padding = 20
      document.querySelectorAll(`${selector} .v-expansion-panel .default-header`)
        .forEach(el => headersSize += el.offsetHeight + padding)

      const sectionMaxHeight = sctionsEl.offsetHeight - headersSize - padding
      el.style['max-height'] = sectionMaxHeight + "px"
    })
  }
}

export {
  setHeight
}
